/* A screen: 64 px margins up to the 1440 px design width, centred beyond. */
.page {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-24);
  min-height: 100dvh;
  max-width: 1440px;
  margin: 0 auto;
  padding: var(--zumpo-space-24) var(--zumpo-space-64) var(--zumpo-space-32);
}

.main {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--zumpo-space-24);
  min-width: 0;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--zumpo-space-12);
  color: var(--zumpo-muted);
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
}

/* The brand line and the language switch, together at the footer's end. */
.end {
  display: inline-flex;
  align-items: center;
  gap: var(--zumpo-space-16);
}

.narrow {
  display: none;
}

@media (max-width: 640px) {
  .page {
    padding: var(--zumpo-space-20)
      max(var(--zumpo-space-20), env(safe-area-inset-right))
      max(var(--zumpo-space-32), env(safe-area-inset-bottom))
      max(var(--zumpo-space-20), env(safe-area-inset-left));
  }

  .wide {
    display: none;
  }

  .narrow {
    display: inline;
  }
}

/* A game in play on a phone is one screen: the page is exactly as tall as the
   viewport, without the footer, spaced tighter, and clear of the home
   indicator and the notch. The board gives the height that is left
   (play-board.tsx), so the controls under it are always on screen. */
@media (max-width: 640px) {
  .page:has([data-play-board]) {
    gap: var(--zumpo-space-12);
    height: 100dvh;
    padding: var(--zumpo-space-12)
      max(var(--zumpo-space-20), env(safe-area-inset-right))
      max(var(--zumpo-space-12), env(safe-area-inset-bottom))
      max(var(--zumpo-space-20), env(safe-area-inset-left));
  }

  .page:has([data-play-board]) .main {
    gap: var(--zumpo-space-12);
    min-height: 0;
  }

  .page:has([data-play-board]) .footer {
    display: none;
  }

  /* A play area with a floor ([data-play-grows]), as a drawing sheet's
     (canvas.module.css) or Draw & Guess's word choices: on a phone too
     short for it with everything else, the page grows past the window and
     scrolls, rather than shrink it under its floor. Every column between
     the page and it then keeps its content's height. The page is at least
     the window as it is now, so a phone that fits keeps its one screen to
     the foot with the browser's bars in or out. */
  .page:has([data-play-grows]) {
    height: auto;
    min-height: 100dvh;
  }

  .page:has([data-play-grows]) .main,
  .page:has([data-play-grows]) .main :has([data-play-grows]) {
    min-height: auto;
  }
}

/* A board fitted to the window's height (fit-height.ts) on a short window,
   such as a laptop's: the room around it is tighter, so the board shrinks
   less. */
@media (min-width: 641px) and (max-height: 800px) {
  .page:has([data-fit-height]) {
    gap: var(--zumpo-space-16);
    padding-top: var(--zumpo-space-16);
    padding-bottom: var(--zumpo-space-16);
  }

  .page:has([data-fit-height]) .main {
    gap: var(--zumpo-space-16);
  }
}

/* A game in play on a short screen wider than a phone, such as a phone on
   its side: tighter, so the board has the most of the height. */
@media (min-width: 641px) and (max-height: 500px) {
  .page:has([data-play-board]) {
    gap: var(--zumpo-space-12);
    padding-top: var(--zumpo-space-12);
    padding-right: max(var(--zumpo-space-24), env(safe-area-inset-right));
    padding-left: max(var(--zumpo-space-24), env(safe-area-inset-left));
  }

  .page:has([data-play-board]) .main {
    gap: var(--zumpo-space-12);
  }
}
